import React, { Component } from 'react';
import GoogleAnalytics4 from './GoogleAnalytics4';
import PropTypes from 'prop-types';

export default class GoogleAnalytics4Wrapper extends Component {
    render() {
        if (this.props.config.measurement_ids){
            return(
                <div>
                    {
                        this.props.config.measurement_ids.map((measurement_id)  => {
                            return  <GoogleAnalytics4 reportEvent={this.props.reportEvent} config={{measurement_id: measurement_id}} key={measurement_id}/>;
                        })
                    }
                </div>
            );    
        }else{
            return(
                <div>
                    <GoogleAnalytics4 reportEvent={this.props.reportEvent} config={this.props.config}/>
                </div>
            );
        }
    }
}

GoogleAnalytics4Wrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
